import { render, staticRenderFns } from "./ChooseRelationOrder.vue?vue&type=template&id=2fbd82ac&scoped=true&"
import script from "./ChooseRelationOrder.vue?vue&type=script&lang=js&"
export * from "./ChooseRelationOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRelationOrder.vue?vue&type=style&index=0&id=2fbd82ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd82ac",
  null
  
)

export default component.exports